import { AsyncBoundary } from "@components/AsyncBoundary";
import { ClosePaneButton } from "@components/ClosePaneButton";
import { PanelError } from "@scribenote/brian-design-system";
import { ViewByUuid, ViewReaderSkeleton } from "@views/ViewByUuid";

/**
 * The main-content pane for a SavedView opened from search: the shared
 * `ViewByUuid` plus a close ✕. Only the uuid is in the URL, so this fetches the
 * tree. `onClear` returns to whatever the workspace was showing, and is also
 * where a delete lands.
 *
 * The window is the corkboard, so this pane lays the reader's sheet straight on
 * the cork - `lifted` holds it further off the board than it sits inside the
 * subject folder's manila.
 */
export const ViewWorkspacePane = ({
  id,
  onClear,
}: {
  id: string;
  onClear: () => void;
}) => (
  <AsyncBoundary
    resetKeys={[id]}
    skeleton={<ViewReaderSkeleton lifted />}
    fallback={(retry) => <PanelError label="view" onRetry={retry} />}
  >
    {/* Reached from search rather than from a subject's folder, so nothing
        around the sheet says whose record this is - the masthead has to. */}
    <ViewByUuid
      id={id}
      onDeleted={onClear}
      trailing={<ClosePaneButton onClick={onClear} />}
      lifted
      withSubject
    />
  </AsyncBoundary>
);
